import { render, staticRenderFns } from "./CommonEventDetails.vue?vue&type=template&id=96a9bcf4&"
import script from "./CommonEventDetails.vue?vue&type=script&lang=js&"
export * from "./CommonEventDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports